import React from 'react';
import { Link } from 'react-router-dom';

const About = () => (
  <div className="min-h-screen bg-[#0e0e0e] text-white px-4 py-8">
    <div className="max-w-2xl mx-auto">
      <Link to="/login" className="text-red-500 hover:text-red-400 text-sm mb-6 inline-block">← Back to Login</Link>
      <h1 className="text-2xl font-bold text-red-500 mb-6">About HubTune</h1>
      <div className="text-white/80 space-y-4 leading-relaxed">
        <p>HubTune is a music platform that connects artists with listeners. Artists can share their music, receive tips, and grow their audience. Listeners can discover new music, support artists, and engage through messages.</p>
        <p>Our mission is to create a fair and supportive ecosystem for independent musicians and their fans.</p>
        <p>HubTune acts as a technology and payment facilitator between listeners and artists. When a listener sends a tip, the payment is processed via an authorized payment gateway and may be temporarily held by the platform only for the purpose of secure processing and artist payout. HubTune may charge a small service or processing fee where applicable.</p>
      </div>
    </div>
  </div>
);

export default About;
